import axios from "@/axios-auth";

const VIEW_STORAGE_KEY = "negocios_view";

function viewInicial() {
  const guardada = localStorage.getItem(VIEW_STORAGE_KEY);

  return guardada === "lista" ? "lista" : "quadro";
}

function filtrosVazios() {
  return {
    busca: null,
    etapa_id: null,
    linha_id: null,
    funcionario_id: null,
    dtini: null,
    dtfim: null
  };
}

function filtrosComissaoVazios() {
  return {
    dtini: null,
    dtfim: null,
    etapa_id: null,
    linha_id: null,
    funcionario_id: null,
    pendentes: false
  };
}

function totaisZerados() {
  return {
    solicitado: 0,
    contratado: 0,
    corte: 0,
    previsto: 0,
    recebido: 0,
    diferenca: 0
  };
}

function filtrosProducaoVazios() {
  return {
    dtini: null,
    dtfim: null,
    linha_id: null
  };
}

function totaisProducaoVazios() {
  return {
    abertas: 0,
    contratadas: 0,
    conversao: null
  };
}

const state = () => ({
  negociosAba: "funil",
  negociosView: viewInicial(),
  negociosColunas: [],
  negociosOportunidades: [],
  negociosPaging: { count: 0, page: 1, limit: 100 },
  negociosOportunidade: null,
  negociosEtapas: [],
  negociosLinhas: [],
  negociosFuncionarios: [],
  negociosConfig: {},
  negociosFiltros: filtrosVazios(),
  negociosOrdem: { sort: null, direction: "asc" },
  negociosItensComissao: [],
  negociosTotaisComissao: totaisZerados(),
  negociosFiltrosComissao: filtrosComissaoVazios(),
  negociosEmiteNotaFiscal: false,
  negociosItensProducao: [],
  negociosTotaisProducao: totaisProducaoVazios(),
  negociosFiltrosProducao: filtrosProducaoVazios(),
  negociosMensagemProducao: "",
  negociosCarregando: false,
  negociosCarregandoComissao: false,
  negociosCarregandoProducao: false,
  negociosSemPermissao: false,
  OpenDialogNegociosOportunidade: false,
  OpenDialogNegociosMotivo: false,
  OpenDialogNegociosData: false,
  OpenDialogNegociosEtapas: false,
  OpenDialogNegociosLinhas: false,
  OpenDialogNegociosConfig: false,
  OpenDialogNegociosReatribuicao: false,
  OpenDialogNegociosBaixa: false,
  OpenDialogNegociosRecebimento: false,
  OpenDialogNegociosExclusao: false
});

const mutations = {
  negociosAba: (state, userData) => {
    state.negociosAba = userData;
  },
  negociosView: (state, userData) => {
    state.negociosView = userData;
    localStorage.setItem(VIEW_STORAGE_KEY, userData);
  },
  negociosColunas: (state, userData) => {
    state.negociosColunas = userData;
  },
  negociosOportunidades: (state, userData) => {
    state.negociosOportunidades = userData;
  },
  negociosPaging: (state, userData) => {
    state.negociosPaging = userData;
  },
  negociosOportunidade: (state, userData) => {
    state.negociosOportunidade = userData;
  },
  negociosEtapas: (state, userData) => {
    state.negociosEtapas = userData;
  },
  negociosLinhas: (state, userData) => {
    state.negociosLinhas = userData;
  },
  negociosFuncionarios: (state, userData) => {
    state.negociosFuncionarios = userData;
  },
  negociosConfig: (state, userData) => {
    state.negociosConfig = userData;
  },
  negociosFiltros: (state, userData) => {
    state.negociosFiltros = { ...state.negociosFiltros, ...userData };
  },
  negociosOrdem: (state, userData) => {
    state.negociosOrdem = userData;
  },
  negociosItensComissao: (state, userData) => {
    state.negociosItensComissao = userData;
  },
  negociosTotaisComissao: (state, userData) => {
    state.negociosTotaisComissao = userData;
  },
  negociosFiltrosComissao: (state, userData) => {
    state.negociosFiltrosComissao = { ...state.negociosFiltrosComissao, ...userData };
  },
  negociosEmiteNotaFiscal: (state, userData) => {
    state.negociosEmiteNotaFiscal = userData;
  },
  negociosItensProducao: (state, userData) => {
    state.negociosItensProducao = userData;
  },
  negociosTotaisProducao: (state, userData) => {
    state.negociosTotaisProducao = userData;
  },
  negociosFiltrosProducao: (state, userData) => {
    state.negociosFiltrosProducao = { ...state.negociosFiltrosProducao, ...userData };
  },
  negociosMensagemProducao: (state, userData) => {
    state.negociosMensagemProducao = userData;
  },
  negociosCarregando: (state, userData) => {
    state.negociosCarregando = userData;
  },
  negociosCarregandoComissao: (state, userData) => {
    state.negociosCarregandoComissao = userData;
  },
  negociosCarregandoProducao: (state, userData) => {
    state.negociosCarregandoProducao = userData;
  },
  negociosSemPermissao: (state, userData) => {
    state.negociosSemPermissao = userData;
  },
  OpenDialogNegociosOportunidade: (state, userData) => {
    state.OpenDialogNegociosOportunidade = userData;
  },
  OpenDialogNegociosMotivo: (state, userData) => {
    state.OpenDialogNegociosMotivo = userData;
  },
  OpenDialogNegociosData: (state, userData) => {
    state.OpenDialogNegociosData = userData;
  },
  OpenDialogNegociosEtapas: (state, userData) => {
    state.OpenDialogNegociosEtapas = userData;
  },
  OpenDialogNegociosLinhas: (state, userData) => {
    state.OpenDialogNegociosLinhas = userData;
  },
  OpenDialogNegociosConfig: (state, userData) => {
    state.OpenDialogNegociosConfig = userData;
  },
  OpenDialogNegociosReatribuicao: (state, userData) => {
    state.OpenDialogNegociosReatribuicao = userData;
  },
  OpenDialogNegociosBaixa: (state, userData) => {
    state.OpenDialogNegociosBaixa = userData;
  },
  OpenDialogNegociosRecebimento: (state, userData) => {
    state.OpenDialogNegociosRecebimento = userData;
  },
  OpenDialogNegociosExclusao: (state, userData) => {
    state.OpenDialogNegociosExclusao = userData;
  },
  negociosCartaMovida: (state, { oportunidadeId, etapaId }) => {
    let carta = null;

    state.negociosColunas.forEach(coluna => {
      const encontrada = coluna.oportunidades.find(o => o.id === oportunidadeId);

      if (encontrada) {
        carta = encontrada;
      }
    });

    if (!carta) {
      return;
    }

    state.negociosColunas.forEach(coluna => {
      const cartas = coluna.oportunidades.filter(o => o.id !== oportunidadeId);

      if (coluna.etapa.id === etapaId) {
        cartas.unshift({ ...carta, etapa_id: etapaId });
      }

      coluna.oportunidades = cartas;
      coluna.quantidade = cartas.length;
      coluna.total_valor = cartas.reduce((total, o) => {
        const valor = o.valor_contratado === null ? o.valor_solicitado : o.valor_contratado;

        return total + Number(valor || 0);
      }, 0);
    });
  },
  negociosOportunidadeAtualizada: (state, oportunidade) => {
    state.negociosColunas.forEach(coluna => {
      coluna.oportunidades = coluna.oportunidades.map(o =>
        o.id === oportunidade.id ? oportunidade : o
      );
    });

    state.negociosOportunidades = state.negociosOportunidades.map(o =>
      o.id === oportunidade.id ? oportunidade : o
    );
  },
  negociosChecklistAtualizado: (state, { oportunidadeId, checklist }) => {
    const progresso = {
      marcados: checklist.marcados,
      total: checklist.total,
      completo: checklist.completo
    };

    if (state.negociosOportunidade && state.negociosOportunidade.id === oportunidadeId) {
      state.negociosOportunidade = {
        ...state.negociosOportunidade,
        checklist,
        checklist_progresso: progresso
      };
    }

    state.negociosColunas.forEach(coluna => {
      coluna.oportunidades = coluna.oportunidades.map(o =>
        o.id === oportunidadeId ? { ...o, checklist_progresso: progresso } : o
      );
    });

    state.negociosOportunidades = state.negociosOportunidades.map(o =>
      o.id === oportunidadeId ? { ...o, checklist_progresso: progresso } : o
    );
  }
};

function semPermissao(res) {
  return Boolean(res.error && res.error.response && res.error.response.status === 403);
}

function envelopeDaResposta(res, mensagemDeFalha) {
  if (!res.error) {
    const corpo = res.data || {};

    if (corpo.data && typeof corpo.data === "object" && !Array.isArray(corpo.data)) {
      return { ...corpo, ...corpo.data };
    }

    return corpo;
  }

  const corpo = res.error.response ? res.error.response.data : null;

  return {
    success: false,
    message: corpo && corpo.message ? corpo.message : mensagemDeFalha,
    errors: corpo && corpo.errors ? corpo.errors : {}
  };
}

const actions = {
  carregarNegociosFunil: ({ dispatch, state }) => {
    return state.negociosView === "quadro"
      ? dispatch("carregarNegociosQuadro")
      : dispatch("carregarNegociosLista");
  },

  carregarNegociosQuadro: ({ commit, state }) => {
    commit("negociosCarregando", true);

    return axios
      .get("/negocios/quadro", { params: state.negociosFiltros })
      .then(res => {
        commit("negociosCarregando", false);

        if (semPermissao(res)) {
          commit("negociosSemPermissao", true);
          return;
        }

        const resposta = envelopeDaResposta(res, "");

        if (!resposta.success) {
          return;
        }

        commit("negociosSemPermissao", false);
        commit("negociosColunas", resposta.colunas);
      });
  },

  carregarNegociosLista: ({ commit, state }) => {
    commit("negociosCarregando", true);

    const params = {
      ...state.negociosFiltros,
      sort: state.negociosOrdem.sort,
      direction: state.negociosOrdem.direction,
      page: state.negociosPaging.page,
      limit: state.negociosPaging.limit
    };

    return axios.get("/negocios", { params }).then(res => {
      commit("negociosCarregando", false);

      if (semPermissao(res)) {
        commit("negociosSemPermissao", true);
        return;
      }

      const resposta = envelopeDaResposta(res, "");

      if (!resposta.success) {
        return;
      }

      commit("negociosSemPermissao", false);
      commit("negociosOportunidades", resposta.oportunidades);
      commit("negociosPaging", resposta.paging);
    });
  },

  carregarNegociosEtapas: ({ commit }) => {
    return axios.get("/negocios/etapas").then(res => {
      const resposta = envelopeDaResposta(res, "");

      if (!resposta.success) {
        return;
      }

      commit("negociosEtapas", resposta.etapas);
    });
  },

  carregarNegociosLinhas: ({ commit }, todas = false) => {
    return axios.get("/negocios/linhas", { params: { all: todas ? 1 : null } }).then(res => {
      const resposta = envelopeDaResposta(res, "");

      if (!resposta.success) {
        return;
      }

      commit("negociosLinhas", resposta.linhas);
    });
  },

  carregarNegociosFuncionarios: ({ commit }) => {
    return axios.get("/cadastros/busca?funcionario=1").then(res => {
      if (res.error) {
        return;
      }

      const resposta = envelopeDaResposta(res, "");
      const funcionarios = Array.isArray(resposta)
        ? resposta
        : resposta.cadastros || (Array.isArray(resposta.data) ? resposta.data : []);

      commit("negociosFuncionarios", funcionarios);
    });
  },

  buscarNegociosCadastro: (context, id) => {
    return axios.get("/cadastros/view/" + id).then(res => {
      return envelopeDaResposta(res, "Não foi possível carregar o cadastro");
    });
  },

  buscarNegociosCadastros: (context, termo) => {
    return axios.get("/cadastros/busca", { params: { term: termo } }).then(res => {
      if (res.error) {
        return [];
      }

      const resposta = envelopeDaResposta(res, "");

      if (Array.isArray(resposta)) {
        return resposta;
      }

      return resposta.cadastros || (Array.isArray(resposta.data) ? resposta.data : []);
    });
  },

  buscarNegociosClientes: (context, termo) => {
    const params = { ativo: 1, cliente: 1, busca: termo, limit: 10 };

    return axios.get("/cadastros", { params }).then(res => {
      const resposta = envelopeDaResposta(res, "Não foi possível buscar os clientes");

      return resposta.success === false ? [] : resposta.cadastros || [];
    });
  },

  carregarNegociosConfig: ({ commit }) => {
    return axios.get("/negocios/config").then(res => {
      const resposta = envelopeDaResposta(res, "");

      if (!resposta.success) {
        return;
      }

      commit("negociosConfig", resposta.opcoes);
      commit("negociosEmiteNotaFiscal", Boolean(resposta.emite_nota_fiscal));
    });
  },

  salvarNegociosConfig: ({ commit }, opcoes) => {
    return axios.post("/negocios/config", opcoes).then(res => {
      const resposta = envelopeDaResposta(res, "Não foi possível salvar as configurações");

      if (resposta.success) {
        commit("negociosConfig", resposta.opcoes);
      }

      return resposta;
    });
  },

  abrirNegociosOportunidade: ({ commit }, id) => {
    return axios.get("/negocios/view/" + id).then(res => {
      const resposta = envelopeDaResposta(res, "Não foi possível abrir a oportunidade");

      if (!resposta.success) {
        return resposta;
      }

      commit("negociosOportunidade", resposta.oportunidade);

      return resposta;
    });
  },

  salvarNegociosOportunidade: ({ commit }, { id, dados }) => {
    const url = id ? "/negocios/edit/" + id : "/negocios/add";

    return axios.post(url, dados).then(res => {
      const resposta = envelopeDaResposta(res, "Não foi possível salvar a oportunidade");

      if (resposta.success && resposta.oportunidade) {
        commit("negociosOportunidade", resposta.oportunidade);
      }

      return resposta;
    });
  },

  moverNegociosOportunidade: ({ commit }, { id, etapaId, motivo, dataAlerta }) => {
    const dados = { etapa_id: etapaId };

    if (motivo) {
      dados.motivo = motivo;
    }

    if (dataAlerta) {
      dados.data_alerta = dataAlerta;
    }

    return axios.post("/negocios/mover/" + id, dados).then(res => {
      const resposta = envelopeDaResposta(res, "Não foi possível mover a oportunidade");

      if (resposta.success && resposta.oportunidade) {
        commit("negociosOportunidadeAtualizada", resposta.oportunidade);
      }

      return resposta;
    });
  },

  addNegociosAnotacao: ({ commit, state }, { id, texto }) => {
    return axios.post("/negocios/add-anotacao/" + id, { texto }).then(res => {
      const resposta = envelopeDaResposta(res, "Não foi possível registrar a anotação");

      if (
        resposta.success &&
        resposta.oportunidade &&
        state.negociosOportunidade &&
        state.negociosOportunidade.id === id
      ) {
        commit("negociosOportunidade", resposta.oportunidade);
      }

      return resposta;
    });
  },

  marcarNegociosChecklistItem: ({ commit }, { oportunidadeId, item, marcado }) => {
    return axios.post("/negocios/checklist/" + oportunidadeId, { item, marcado }).then(res => {
      const resposta = envelopeDaResposta(res, "Não foi possível atualizar o checklist");

      if (resposta.success && resposta.checklist) {
        commit("negociosChecklistAtualizado", { oportunidadeId, checklist: resposta.checklist });
      }

      return resposta;
    });
  },

  excluirNegociosOportunidade: (context, id) => {
    return axios.post("/negocios/delete/" + id).then(res => {
      return envelopeDaResposta(res, "Não foi possível excluir a oportunidade");
    });
  },

  salvarNegociosEtapa: ({ dispatch }, { id, dados }) => {
    const url = id ? "/negocios/edit-etapa/" + id : "/negocios/add-etapa";

    return axios.post(url, dados).then(res => {
      const resposta = envelopeDaResposta(res, "Não foi possível salvar a etapa");

      if (resposta.success) {
        dispatch("carregarNegociosEtapas");
      }

      return resposta;
    });
  },

  excluirNegociosEtapa: ({ dispatch }, { id, etapaDestinoId }) => {
    const dados = etapaDestinoId ? { etapa_destino_id: etapaDestinoId } : {};

    return axios.post("/negocios/delete-etapa/" + id, dados).then(res => {
      const resposta = envelopeDaResposta(res, "Não foi possível excluir a etapa");

      if (resposta.success) {
        dispatch("carregarNegociosEtapas");
      }

      return resposta;
    });
  },

  salvarNegociosLinha: ({ dispatch }, { id, dados }) => {
    const url = id ? "/negocios/edit-linha/" + id : "/negocios/add-linha";

    return axios.post(url, dados).then(res => {
      const resposta = envelopeDaResposta(res, "Não foi possível salvar a linha");

      if (resposta.success) {
        dispatch("carregarNegociosLinhas", true);
      }

      return resposta;
    });
  },

  excluirNegociosLinha: ({ dispatch }, id) => {
    return axios.post("/negocios/delete-linha/" + id).then(res => {
      const resposta = envelopeDaResposta(res, "Não foi possível excluir a linha");

      if (resposta.success) {
        dispatch("carregarNegociosLinhas", true);
      }

      return resposta;
    });
  },

  carregarNegociosComissoes: ({ commit, state }) => {
    commit("negociosCarregandoComissao", true);

    const params = { ...state.negociosFiltrosComissao };
    params.pendentes = params.pendentes ? 1 : null;

    return axios.get("/negocios/comissoes", { params }).then(res => {
      commit("negociosCarregandoComissao", false);

      if (semPermissao(res)) {
        commit("negociosSemPermissao", true);
        return;
      }

      const resposta = envelopeDaResposta(res, "");

      if (!resposta.success) {
        return;
      }

      commit("negociosItensComissao", resposta.itens);
      commit("negociosTotaisComissao", resposta.totais);
    });
  },

  exportarNegociosComissoes: ({ state }) => {
    const params = { ...state.negociosFiltrosComissao };
    params.pendentes = params.pendentes ? 1 : null;

    return axios.get("/negocios/exportar-comissoes", { params }).then(res => {
      return envelopeDaResposta(res, "Não foi possível exportar o relatório");
    });
  },

  carregarNegociosProducao: ({ commit, state }) => {
    commit("negociosCarregandoProducao", true);

    const params = { ...state.negociosFiltrosProducao };

    return axios.get("/negocios/producao", { params }).then(res => {
      commit("negociosCarregandoProducao", false);

      if (semPermissao(res)) {
        commit("negociosSemPermissao", true);
        return;
      }

      const resposta = envelopeDaResposta(res, "");

      if (!resposta.success) {
        return;
      }

      commit("negociosSemPermissao", false);
      commit("negociosItensProducao", resposta.operadores);
      commit("negociosTotaisProducao", resposta.totais);
      commit("negociosMensagemProducao", resposta.message || "");
    });
  },

  exportarNegociosProducao: ({ state }) => {
    const params = { ...state.negociosFiltrosProducao };

    return axios.get("/negocios/exportar-producao", { params }).then(res => {
      return envelopeDaResposta(res, "Não foi possível exportar o relatório");
    });
  },

  registrarNegociosRecebimento: (context, recebimentos) => {
    return axios.post("/negocios/receber", { recebimentos }).then(res => {
      return envelopeDaResposta(res, "Não foi possível registrar a comissão");
    });
  },

  emitirNegociosNotaFiscal: (context, recebimentoIds) => {
    return axios.post("/negocios/emitir-nota-fiscal", { recebimentos: recebimentoIds }).then(res => {
      return envelopeDaResposta(res, "Não foi possível emitir a nota fiscal");
    });
  },

  salvarNegociosRecebimento: (context, { id, dados }) => {
    return axios.post("/negocios/edit-recebimento/" + id, dados).then(res => {
      return envelopeDaResposta(res, "Não foi possível corrigir o recebimento");
    });
  },

  excluirNegociosRecebimento: (context, id) => {
    return axios.post("/negocios/delete-recebimento/" + id).then(res => {
      return envelopeDaResposta(res, "Não foi possível excluir o recebimento");
    });
  },

  carregarNegociosPreviaCarteira: (context, { origemId, destinoId }) => {
    const params = { origem_id: origemId, destino_id: destinoId };

    return axios.get("/negocios/previa-carteira", { params }).then(res => {
      return envelopeDaResposta(res, "Não foi possível calcular a prévia da carteira");
    });
  },

  transferirNegociosCarteira: (context, { origemId, destinoId }) => {
    const dados = { origem_id: origemId, destino_id: destinoId };

    return axios.post("/negocios/transferir-carteira", dados).then(res => {
      return envelopeDaResposta(res, "Não foi possível transferir a carteira");
    });
  },

  limparNegociosFiltros: ({ commit, dispatch }) => {
    commit("negociosFiltros", filtrosVazios());
    commit("negociosPaging", { count: 0, page: 1, limit: 100 });

    return dispatch("carregarNegociosFunil");
  }
};

const getters = {
  negociosAba: state => state.negociosAba,
  negociosView: state => state.negociosView,
  negociosColunas: state => state.negociosColunas,
  negociosOportunidades: state => state.negociosOportunidades,
  negociosPaging: state => state.negociosPaging,
  negociosOportunidade: state => state.negociosOportunidade,
  negociosEtapas: state => state.negociosEtapas,
  negociosLinhas: state => state.negociosLinhas,
  negociosFuncionarios: state => state.negociosFuncionarios,
  negociosConfig: state => state.negociosConfig,
  negociosFiltros: state => state.negociosFiltros,
  negociosOrdem: state => state.negociosOrdem,
  negociosItensComissao: state => state.negociosItensComissao,
  negociosTotaisComissao: state => state.negociosTotaisComissao,
  negociosFiltrosComissao: state => state.negociosFiltrosComissao,
  negociosEmiteNotaFiscal: state => state.negociosEmiteNotaFiscal,
  negociosItensProducao: state => state.negociosItensProducao,
  negociosTotaisProducao: state => state.negociosTotaisProducao,
  negociosFiltrosProducao: state => state.negociosFiltrosProducao,
  negociosMensagemProducao: state => state.negociosMensagemProducao,
  negociosCarregando: state => state.negociosCarregando,
  negociosCarregandoComissao: state => state.negociosCarregandoComissao,
  negociosCarregandoProducao: state => state.negociosCarregandoProducao,
  negociosSemPermissao: state => state.negociosSemPermissao,
  OpenDialogNegociosOportunidade: state => state.OpenDialogNegociosOportunidade,
  OpenDialogNegociosMotivo: state => state.OpenDialogNegociosMotivo,
  OpenDialogNegociosData: state => state.OpenDialogNegociosData,
  OpenDialogNegociosEtapas: state => state.OpenDialogNegociosEtapas,
  OpenDialogNegociosLinhas: state => state.OpenDialogNegociosLinhas,
  OpenDialogNegociosConfig: state => state.OpenDialogNegociosConfig,
  OpenDialogNegociosReatribuicao: state => state.OpenDialogNegociosReatribuicao,
  OpenDialogNegociosBaixa: state => state.OpenDialogNegociosBaixa,
  OpenDialogNegociosRecebimento: state => state.OpenDialogNegociosRecebimento,
  OpenDialogNegociosExclusao: state => state.OpenDialogNegociosExclusao,
  negociosLinhasAtivas: state => state.negociosLinhas.filter(linha => linha.ativo),
  negociosFiltrosExtrasAtivos: state => {
    const filtros = state.negociosFiltros;

    return ["linha_id", "funcionario_id", "dtini", "dtfim"].filter(chave => filtros[chave]).length;
  }
};

export default {
  state,
  mutations,
  actions,
  getters
};
